module.exports = __webpack_public_path__ + "img/kangmingjian_img2.35bfb35a.jpg";